export function base64UrlToBase64(base64url: string): string {
  // To convert the characters in Base64Url to Base64 these characters need to be replaced:
  // 1. '-' --> '+'
  // 2. '_' --> '/'
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/')

  // Padding is needed in Base64 encoding but not in Base64Url encoding.
  // In Base64, every 3 bytes of data are converted into 4 ASCII characters. So,
  // if the data isn't a multiple of 3 bytes (aka 4 ASCII characters in the Base64Url string),
  // padding must be added to make sure the last group has 3 bytes (aka 4 ASCII characters).
  const padding = base64.length % 4
  if (padding) {
    return base64 + '='.repeat(4 - padding)
  }

  return base64
}
